export default __webpack_public_path__ + "static/media/user.07fe7c61.svg";